var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Create Catch-all ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "p",
              {
                staticClass: "body-2"
              },
              [
                _vm._v(" Mail sent to any address on "),
                _c("strong", [_vm._v(_vm._s(_vm.mailbox.domain))]),
                _vm._v(
                  " that has no mailbox, alias or forwarder will be delivered to "
                ),
                _c("strong", [_vm._v(_vm._s(_vm.mailbox.email))]),
                _vm._v(". ")
              ]
            ),
            _vm.loading
              ? _c("gg-loading", {
                  attrs: {
                    loading: true,
                    type: "list-item"
                  }
                })
              : _vm.isCurrent
              ? _c(
                  "p",
                  {
                    staticClass: "body-2 mb-0"
                  },
                  [
                    _vm._v(
                      " This mailbox is already the catch-all for " +
                        _vm._s(_vm.mailbox.domain) +
                        ". "
                    )
                  ]
                )
              : _vm.current
              ? _c(
                  "p",
                  {
                    staticClass: "body-2 mb-0"
                  },
                  [
                    _vm._v(
                      " Unrouted mail for " +
                        _vm._s(_vm.mailbox.domain) +
                        " currently goes to "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.current))]),
                    _vm._v(". It will be replaced. ")
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.saving,
                  disabled: _vm.loading || _vm.isCurrent
                },
                on: {
                  click: _vm.save
                }
              },
              [_vm._v(" Create Catch-all ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }